import { useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import { Button, TextField } from '@mui/material';
import { useSnackbar } from 'notistack';
import { DarkTooltip } from '../DarkTooltip';

const ButtonStyle = theme => ({
  background: 'none',
  color: 'inherit',
  border: 'none',
  padding: 0,
  font: 'inherit',
  cursor: 'pointer',
  outline: 'inherit',
  justifyContent: 'left',
  borderBottom: `1px solid ${theme.palette.border}`,
  borderRadius: 'unset',
});

const InlineEdit = ({ id, value, name, onUpdate, tooltipTitle, min, sx }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [editingValue, setEditingValue] = useState(value);
  const [clicked, setClicked] = useState(false);
  const theme = useTheme();

  useEffect(() => {
    setEditingValue(value);
  }, [value]);

  const handleChange = event => {
    if (event.target.value < min) return;
    setEditingValue(Number(event.target.value));
  };

  const handleClick = () => {
    setClicked(true);
  };

  const update = async value => {
    try {
      await onUpdate(id, { [name]: value });
      enqueueSnackbar('Successfully updated', {
        variant: 'success',
      });
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: 'error',
      });
    }
  };

  const onEnter = async event => {
    if (event.key === 'Enter') {
      if (value !== Number(event.target.value)) {
        update(Number(event.target.value));
      }
      setClicked(false);
    }
  };

  const handleBlur = async event => {
    setClicked(false);
    if (value !== Number(event.target.value)) {
      update(Number(event.target.value));
    }
  };

  const editComponent = tooltipTitle ? (
    <DarkTooltip title={tooltipTitle}>
      <Button type="button" onClick={handleClick} sx={ButtonStyle(theme)} data-cy={name}>
        {value}
      </Button>
    </DarkTooltip>
  ) : (
    <Button type="button" onClick={handleClick} sx={ButtonStyle(theme)} data-cy={name}>
      {value}
    </Button>
  );

  return clicked ? (
    <TextField
      value={editingValue || ''}
      onChange={handleChange}
      onBlur={handleBlur}
      placeholder="123"
      type="number"
      variant="standard"
      onKeyDown={onEnter}
      sx={{ width: '4rem', ...sx }}
      slotProps={{ htmlInput: { min } }}
      autoFocus
    />
  ) : (
    editComponent
  );
};

export default InlineEdit;
